<template>
  <tr class="row-details">
    <td class="v-align-middle" colspan="6" v-if="readyToRender" >
      <div class="cau-container">
        <customer 
          :customer="customer" 
          :is-details="isDetails"
        ></customer>

        <div class="cau-address">
          <div class="cau-address-head">
            <h4>Adresse(s) concernée(s)</h4>
          </div>

          <customer-address :address="validationRequestable"></customer-address>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { apiV2 } from 'store/api'
import Customer from "./ValidationRequestable/CustomerV2"
import CustomerAddress from "./ValidationRequestable/AddressV2"

export default {
  name:"CustomerAddressUpdate",

  props:["validationRequestId", "isDetails"],

  components:{
    Customer,
    CustomerAddress
  },

  data() {
    return {
      validationRequest: null
    }
  },

  computed:{
    readyToRender(){
      return this.validationRequest != null
    },

    customer() {
      return this.validationRequest.included.customer
    },

    validationRequestable() {
      return this.validationRequest.included.validation_requestable
    }
  },

  created() {
    const params = {
      with: 'customer,validation_requestable'
    }

    apiV2.getValidationRequest(this.validationRequestId, params)
      .then((response) => this.validationRequest = response.data.data)
  }
}
</script>

<style scoped>
.cau-container {
  display: flex;
}

.cau-container > div { margin-right: 15px; }
.cau-container > div:last-child { margin-right: 0; }

.cau-address {
  border:solid 1px lightgrey;
  padding: 0 15px;
  background-color: white;
  width: 100%;
}

.row-details td {
  background-color: #e0e0e0
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/CustomerAddressUpdate.vue